import {client} from '@/lib/api-client'
import {LeagueModel} from '@/models/League'

export const getLeagues = async () => {
  const leaguesPayload = await client.get('leagues').json()

  return LeagueModel.normalizePayload(leaguesPayload)
}
